import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { Form, Nav } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import Select from 'react-select'

import { sendEmailSchema } from '../../util/validationSchema'
import { getAllRegion } from '../../redux/slices/regionSlice'
import { getAllCleanersInfo, getAllClientsInfo, getAllTemplate, sendEmailTemplates } from '../../redux/slices/templateSlice'
import { SpinnerContext } from '../../context/spinnerContext'
import { errorToast, successToast } from '../../util/Toast/toast'
import { CLEANER, CLIENT } from '../../util/constant'
import { formatCustomTrim } from '../../helper/function'

const SendEmail = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const defaultRole = location?.state
  const { allRegion } = useSelector(({ region }) => region)
  const { changeLoader } = useContext(SpinnerContext)
  const { templatesData, clientsData, cleanerData } = useSelector((state) => state.templates)
  const [selectEmailSubject, setSelectEmailSubject] = useState(false)
  const [role, setRole] = useState(defaultRole || CLIENT)
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    reset,
    formState: { errors },
    clearErrors
  } = useForm({
    resolver: yupResolver(sendEmailSchema),
    defaultValues: {}
  })

  const templateSendingToUser = role === CLIENT ? clientsData?.clients : cleanerData?.cleaners

  const selectAllDisable = useMemo(() => !selectEmailSubject || templateSendingToUser?.length <= 0, [selectEmailSubject, templateSendingToUser])

  const regionFilter = watch('region')
  const nameFilter = watch('name')

  const defultValues = {
    name: '',
    subject: null,
    body: '',
    region: '',
    sendingTo: null,
    selectAll: false
  }

  const onSubmit = (data) => {
    const payload = {
      template_id: data?.subject?.template_id,
      userEmails: data?.sendingTo?.map((item) => item.email)?.filter((data) => data)
    }
    changeLoader(true)
    dispatch(sendEmailTemplates(payload)).then(({ payload, error }) => {
      if (payload?.status === 200) {
        changeLoader(false)
        successToast(payload?.data?.status_message || 'Success!')
        reset(defultValues)
      } else {
        errorToast(payload?.data?.status_message || error?.message)
        changeLoader(false)
      }
    })
  }

  useEffect(() => {
    getStateCityData()
  }, [])

  useEffect(() => {
    fetchAllEmail()
  }, [role])

  useEffect(() => {
    setValue('sendingTo', [])
    setValue('selectAll', false)
  }, [regionFilter])

  useEffect(() => {
    if (role == 'CLIENT') {
      fetchClients()
    } else {
      fetchCleaner()
    }
  }, [role, regionFilter, nameFilter])

  const getStateCityData = () => {
    dispatch(getAllRegion())
      .then(() => {})
      .catch((err) => {
        console.log('err :>> ', err)
      })
  }

  const fetchAllEmail = () => {
    changeLoader(true)
    const payload = {
      sort_column: 'created_at',
      sort_order: 'DESC',
      role: role,
      template_type: 'EMAIL'
    }
    dispatch(getAllTemplate(payload))
      .then(() => {
        changeLoader(false)
      })
      .catch(() => {
        changeLoader(false)
      })
  }

  const fetchClients = () => {
    const payload = {
      name: formatCustomTrim(nameFilter) || '',
      region: regionFilter?.region_id || ''
    }
    dispatch(getAllClientsInfo(payload))
      .then(() => {})
      .catch((err) => {
        console.log('err :>> ', err)
      })
  }

  const fetchCleaner = () => {
    const payload = {
      name: formatCustomTrim(nameFilter) || '',
      region: regionFilter?.region_id || ''
    }
    dispatch(getAllCleanersInfo(payload))
      .then(() => {})
      .catch((err) => {
        console.log('err :>> ', err)
      })
  }

  const onHandleToggle = (role) => {
    setRole(role)
    reset(defultValues)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="page-wrapper email-cleaners">
        <div className="content">
          <div className="page-header">
            <div className="content-page-header">
              <h5 className="sec_title_text d-flex align-items-center" onClick={() => navigate(`/emails`)}>
                <i className="fa fa-angle-left fs-5 me-2" aria-hidden="true"></i>
                Back to Email
              </h5>

              <div className="d-flex" style={{ justifyContent: 'flex-end' }}>
                <Nav className="d-flex gap-1">
                  <Nav.Item
                    className={`btn btn-small ${role === CLIENT ? 'toggle-button-sky sky_btn' : 'toggle-common-outline-btn common-outline-btn'}`}
                    onClick={() => onHandleToggle(CLIENT)}
                  >
                    <Nav.Link className={`text p-0 custom-link`} eventKey="client">
                      Client
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item
                    className={`btn btn-small ${role === CLEANER ? 'toggle-button-sky sky_btn' : 'toggle-common-outline-btn common-outline-btn'}`}
                    onClick={() => onHandleToggle(CLEANER)}
                  >
                    <Nav.Link className={`text p-0 custom-link`} eventKey="cleaners">
                      Cleaners
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="common_heading_div">
              <h4>Filter</h4>
            </div>
            <div className="common_card_div upcoming_cleanings_space_div">
              <div className="col-md-12">
                <div className="card-body add-vendor pb-4">
                  <div className="form-group-item border-0 pb-0 mb-0">
                    <div className="row">
                      <div className="col-lg-6 col-sm-6">
                        <div className="form-group">
                          <label>Search</label>
                          <Controller
                            name="name"
                            control={control}
                            render={({ field: { value, onChange } }) => (
                              <>
                                <input
                                  className="form-control bg-transparent"
                                  autoComplete="off"
                                  value={value}
                                  type="text"
                                  placeholder="Search Name"
                                  onChange={(val) => {
                                    onChange(val)
                                  }}
                                />
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="form-group input_text border-remove">
                          <label>Regions</label>
                          <Controller
                            name="region"
                            control={control}
                            render={({ field }) => (
                              <Select
                                {...field}
                                className={`react-selectcomponent form-control select-box-filed`}
                                getOptionLabel={(option) => `${option.region}`}
                                getOptionValue={(option) => `${option.region_id}`}
                                options={allRegion || []}
                                isClearable
                                isSearchable={true}
                                placeholder={`Select Region`}
                                classNamePrefix="select_kanakku"
                                onChange={(option) => {
                                  field.onChange(option)
                                  setValue('selectAll', false)
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="common_heading_div">
              <h4>Send Email</h4>
            </div>
            <div className="common_card_div upcoming_cleanings_space_div">
              <div className="col-lg-12 col-sm-12">
                <div className="form-group">
                  <label>
                    Email Subject <span className="text-danger"> *</span>
                  </label>
                  <Controller
                    name="subject"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Select
                          {...field}
                          className={`react-selectcomponent form-control select-box-filed remove_border_cls`}
                          getOptionLabel={(option) => `${option.subject}`}
                          getOptionValue={(option) => `${option.template_id}`}
                          options={templatesData?.templates || []}
                          isClearable
                          isSearchable={true}
                          placeholder={`Select Email Subject`}
                          classNamePrefix="select_kanakku"
                          defaultValue={''}
                          onChange={(option) => {
                            field.onChange(option)
                            setSelectEmailSubject(true)
                            if (option?.body) {
                              setValue('body', option?.body)
                              clearErrors('body')
                            }
                          }}
                        />
                        <small>{errors?.subject?.message}</small>
                      </>
                    )}
                  />
                </div>
              </div>
              <div className="col-lg-12 col-sm-12">
                <div className="form-group">
                  <label>
                    Message <span className="text-danger"> *</span>
                  </label>
                  <Controller
                    name="body"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <>
                        <textarea
                          className="form-control bg-transparent"
                          autoComplete="off"
                          value={value}
                          rows={5}
                          type="text"
                          placeholder="Message"
                          onChange={(val) => {
                            onChange(val)
                          }}
                        />
                        <small>{errors?.body?.message}</small>
                      </>
                    )}
                  />
                </div>
              </div>
              <div className="col-lg-12 col-sm-12">
                <div className="form-group input_text">
                  <label>
                    Sending To <span className="text-danger"> *</span>
                  </label>
                  <Controller
                    name="sendingTo"
                    control={control}
                    render={({ field: { onChange, ...rest } }) => (
                      <>
                        <Select
                          {...rest}
                          isMulti
                          isDisabled={!selectEmailSubject}
                          className={`react-selectcomponent form-control select-box-filed remove_border_cls `}
                          getOptionLabel={(option) => `${option.first_name} ${option.last_name} ${option.email ? `(${option.email})` : ''}`}
                          getOptionValue={(option) => (role === CLIENT ? `${option.client_id}` : `${option.cleaners_id}`)}
                          options={templateSendingToUser || []}
                          isClearable
                          isSearchable={true}
                          placeholder={`Select Send To`}
                          classNamePrefix="select_kanakku"
                          defaultValue={''}
                          onChange={(val) => {
                            onChange(val)
                            if (watch('sendingTo').length == templateSendingToUser?.length) {
                              setValue('selectAll', true)
                            } else {
                              setValue('selectAll', false)
                            }
                          }}
                        />
                        <small>{errors?.sendingTo?.message}</small>
                      </>
                    )}
                  />
                </div>
              </div>
              <div className="col-lg-12 col-sm-12">
                <div className="form-group input_text border-remove">
                  <Controller
                    key={`status-control-2`}
                    name={`selectAll`}
                    control={control}
                    defaultValue={false}
                    render={({ field: { value } }) => (
                      <Form.Check
                        type="switch"
                        id={`custom-switch-selectAll`}
                        label={`Send to All`}
                        checked={value}
                        disabled={selectAllDisable}
                        onChange={(event) => {
                          const { checked } = event.target
                          setValue('selectAll', checked)
                          if (checked) {
                            setValue('sendingTo', templateSendingToUser)
                          } else {
                            setValue('sendingTo', [])
                          }
                        }}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="col-lg-12 col-sm-12">
                <button className="btn btn-primary" type="submit">
                  Send Email
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  )
}

export default SendEmail
